import constants from './constants';
import getApiHeaders from './apiHeaders.js';

const BATCH_INTERVAL = 5000;
const DEDUP_WINDOW = 10000;

const errorQueue = [];
const recentErrors = new Map();
let batchTimer = null;

const flushErrors = () => {
    if (errorQueue.length === 0) return;

    const errors = errorQueue.splice(0);
    try {
        fetch(constants.reportError, {
            method: 'POST',
            headers: getApiHeaders(),
            body: JSON.stringify({ errors }),
        }).catch(() => {});
    } catch (_) {}
};

const scheduleBatch = () => {
    if (batchTimer) return;
    batchTimer = setTimeout(() => {
        batchTimer = null;
        flushErrors();
    }, BATCH_INTERVAL);
};

const reportError = (errorData) => {
    try {
        const key = errorData.message || '';
        const now = Date.now();

        if (recentErrors.has(key) && now - recentErrors.get(key) < DEDUP_WINDOW) {
            return;
        }
        recentErrors.set(key, now);

        errorQueue.push({
            ...errorData,
            url: window.location.href,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString(),
        });

        scheduleBatch();
    } catch (_) {}
};

const initErrorReporting = () => {
    window.onerror = (message, source, lineno, colno, error) => {
        reportError({
            message,
            stack: error?.stack,
            source,
            lineno,
            colno,
            type: 'uncaught',
        });
    };

    window.addEventListener('unhandledrejection', (event) => {
        reportError({
            message: event.reason?.message || String(event.reason),
            stack: event.reason?.stack,
            type: 'unhandledrejection',
        });
    });

    const originalConsoleError = console.error;
    console.error = (...args) => {
        originalConsoleError.apply(console, args);
        try {
            const message = args.map(arg => {
                if (arg instanceof Error) return arg.message;
                if (typeof arg === 'string') return arg;
                try { return JSON.stringify(arg); } catch (_) { return String(arg); }
            }).join(' ');
            const stack = args.find(arg => arg instanceof Error)?.stack;
            reportError({ message, stack, type: 'console.error' });
        } catch (_) {}
    };

    // Flush remaining errors before page unload
    window.addEventListener('beforeunload', flushErrors);
};

export { initErrorReporting };
export default reportError;
